var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthPurpleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 4C16.418 4 20 7.582 20 12C20 16.418 16.418 20 12 20C7.582 20 4 16.418 4 12C4 7.582 7.582 4 12 4Z",
    fill: "#46109B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1918 5.62845L12.1086 5.91101V14.1103L12.1918 14.1933L15.9978 11.9435L12.1918 5.62845Z",
    fill: "#46109B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.192 5.62842L8.38599 11.9435L12.192 14.1933V10.2136V5.62842Z",
    fill: "#46109B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1917 14.9139L12.1449 14.971V17.8917L12.1917 18.0286L16 12.6653L12.1917 14.9139Z",
    fill: "#46109B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1919 18.0286V14.9139L8.38586 12.6653L12.1919 18.0286Z",
    fill: "#46109B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.192 14.1933L15.998 11.9436L12.192 10.2137V14.1933Z",
    fill: "#46109B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38586 11.9436L12.1918 14.1933V10.2137L8.38586 11.9436Z",
    fill: "#46109B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthPurpleIcon);
export default __webpack_public_path__ + "static/media/eth-purple-icon.4b1184017fd76a4595e8bf52157e2075.svg";
export { ForwardRef as ReactComponent };